/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'yurstrap';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    color: PropTypes.oneOf([
        'primary',
        'premium',
        'error',
        'secondary',
        'facebook',
        'tertiary',
    ]),
    disabled: PropTypes.bool,
    expand: PropTypes.bool,
    square: PropTypes.bool,
    tips: PropTypes.string,
    onClick: PropTypes.func,
};

const defaultProps = {
    ...commonDefaultProps,
    color: 'primary',
    disabled: false,
    expand: false,
    square: false,
    tips: 'Plus d\'actions',
};

const PopoverToggle = (props) => {
    const classNames = [
        'c-popover__toggle',
        'c-popover__toggle-react',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];

    return (
        <Button
            aria-label={props.tips}
            color={props.color}
            className={concatClassNames(classNames)}
            disabled={props.disabled}
            expand={props.expand}
            square={props.square}
            {...filterProps(propTypes, props)}
            onClick={props.onClick}
        >
            {props.children}
        </Button>
    );
};

PopoverToggle.propTypes = propTypes;

PopoverToggle.defaultProps = defaultProps;

export default PopoverToggle;
